/* eslint-disable consistent-return, default-case, no-param-reassign */
/*
 *
 * Documents reducer
 *
 */

import produce from 'immer';

/* eslint-disable sort-imports */
import { RESET_SWITCH_LOAN_STATE, RESET_USER_STATE } from '../Main/constants';
import {
  CHANGE_STATEMENTS_FILTER,
  DOWNLOAD_DOCUMENT,
  DOWNLOAD_DOCUMENT_FAILURE,
  FETCH_DOCUMENTS_HOME,
  FETCH_DOCUMENTS_HOME_FAILURE,
  FETCH_DOCUMENTS_HOME_SUCCESS,
  FETCH_STATEMENT,
  FETCH_STATEMENT_CANCELLED,
  FETCH_STATEMENT_FAILURE,
  FETCH_STATEMENT_SUCCESS,
  FETCH_STATEMENTS,
  FETCH_STATEMENTS_FAILURE,
  FETCH_STATEMENTS_SUCCESS,
  RESET_ERRORS,
  RESET_STATEMENTS_STATE,
  SET_HOME_LOADING_STEP,
  SET_STATEMENTS_FILE,
  SET_STATEMENTS_PAGES_RENDERED,
  TOGGLE_STATEMENTS_DRAWER,
  UPDATE_REFETCH_STATUS,
} from './constants';

export const initialState = {
  error: {
    bannerError: false,
    serviceError: false,
  },
  home: {
    numPayoff: -1,
    numStatements: -1,
  },
  homeLoadingStep: 0,
  loading: {
    home: false,
    statement: false,
    statements: false,
  },
  shouldDocumentsHomeRefetch: true,
  statements: {
    file: {},
    isDrawerOpen: false,
    itemsPerPage: 20,
    pagesRendered: -1,
    selectedFilter: 'allTypes',
    statements: [],
  },
};

const documentsReducer = produce((draft, { payload, type }) => {
  switch (type) {
    case CHANGE_STATEMENTS_FILTER: {
      const { filter } = payload;
      draft.error.bannerError = false;
      draft.statements.selectedFilter = filter;
      break;
    }
    case DOWNLOAD_DOCUMENT: {
      draft.error.bannerError = false;
      break;
    }
    case DOWNLOAD_DOCUMENT_FAILURE: {
      const { error } = payload;
      draft.error.bannerError = error;
      break;
    }
    case FETCH_DOCUMENTS_HOME: {
      draft.error.serviceError = false;
      draft.loading.home = true;
      draft.homeLoadingStep = 1;
      draft.shouldDocumentsHomeRefetch = false;
      break;
    }
    case FETCH_DOCUMENTS_HOME_FAILURE: {
      const { error } = payload;
      draft.error.serviceError = error;
      draft.loading.home = false;
      draft.homeLoadingStep = 0;
      break;
    }
    case FETCH_DOCUMENTS_HOME_SUCCESS: {
      const { numPayoff, numStatements } = payload;
      draft.home.numPayoff = numPayoff;
      draft.home.numStatements = numStatements;
      draft.loading.home = false;
      draft.homeLoadingStep = 0;
      break;
    }
    case FETCH_STATEMENT: {
      draft.error.bannerError = false;
      draft.loading.statement = true;
      break;
    }
    case FETCH_STATEMENT_CANCELLED: {
      draft.loading.statement = false;
      break;
    }
    case FETCH_STATEMENT_FAILURE: {
      const { error } = payload;
      draft.error.bannerError = error;
      draft.loading.statement = false;
      break;
    }
    case FETCH_STATEMENT_SUCCESS: {
      draft.loading.statement = false;
      break;
    }
    case FETCH_STATEMENTS: {
      draft.error.serviceError = false;
      draft.loading.statements = true;
      break;
    }
    case FETCH_STATEMENTS_FAILURE: {
      const { error } = payload;
      draft.error.serviceError = error;
      draft.loading.statements = false;
      break;
    }
    case FETCH_STATEMENTS_SUCCESS: {
      const { statements } = payload;
      draft.loading.statements = false;
      draft.statements.pagesRendered = 1;
      draft.statements.statements = statements;
      break;
    }
    case RESET_ERRORS: {
      draft.error.bannerError = false;
      draft.error.serviceError = false;
      break;
    }
    case RESET_STATEMENTS_STATE: {
      draft.error.bannerError = initialState.error.bannerError;
      draft.error.serviceError = initialState.error.serviceError;
      draft.loading.statements = true;
      draft.statements = initialState.statements;
      break;
    }
    case RESET_SWITCH_LOAN_STATE: {
      return initialState;
    }
    case RESET_USER_STATE: {
      return initialState;
    }
    case SET_HOME_LOADING_STEP: {
      const { step } = payload;
      draft.homeLoadingStep = step;
      break;
    }
    case SET_STATEMENTS_FILE: {
      const { fileName, uri } = payload || {};
      if (fileName && uri) {
        draft.statements.file = { fileName, uri };
      } else {
        draft.statements.file = {};
      }
      break;
    }
    case SET_STATEMENTS_PAGES_RENDERED: {
      const { number } = payload;
      draft.statements.pagesRendered = number;
      break;
    }
    case TOGGLE_STATEMENTS_DRAWER: {
      const { drawerState } = payload;
      draft.statements.isDrawerOpen = drawerState;
      break;
    }
    case UPDATE_REFETCH_STATUS: {
      const { shouldUpdate } = payload;
      draft.shouldDocumentsHomeRefetch = shouldUpdate;
      break;
    }
  }
}, initialState);

export default documentsReducer;
